<template>
    <!-- Start Boxes Area -->
    <section class="boxes-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-box">
                        <div class="icon">
                            <feather type="layers"></feather>
                        </div>
                        <h3>Planning</h3>
                        <p>Using modern technology we have come up with an innovative and effective way for managing your requirements.</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-box bg-f78acb">
                        <div class="icon">
                            <feather type="book"></feather>
                        </div>
                        <h3>Analysis</h3>
                        <p>After thoroughly analyzing all the problems we have made all of our Website and Softwares as user friendly as possible.</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-box bg-c679e3">
                        <div class="icon">
                            <feather type="code"></feather>
                        </div>
                        <h3>Design & Development</h3>
                        <p>The design & development of a Software should be unique and error free so that everyone can use it very easily</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-box bg-eb6b3d">
                        <div class="icon">
                            <feather type="smile"></feather>
                        </div>
                        <h3>Satisfaction</h3>
                        <p>What makes a great Softwares product? A great Software product satisfies and fulfills a deep need for its users.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Boxes Area -->
</template>

<script>
export default {
    name: 'BoxesArea'
}
</script>